import { EMPTY, of } from 'rxjs';
import { mergeMap, takeWhile } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import Global from '../../store/global-selectors';
import { UnitConversionService } from '../../services/unit-conversion-service';
import { WeightUnit } from '../../enums/weight-unit';
import { DimensionUnit } from '../../enums/dimension-unit';

import * as Actions from './ss-connect.actions';

export const convertReadScaleResponse$ = (action$, getState, selectedScalesWorkstationId) =>
  action$.pipe(
    ofType(Actions.READ_SCALE_RESPONSE),
    takeWhile(({ workstationId }) => {
      if (!selectedScalesWorkstationId) {
        // user has not set a scale yet
        return false;
      }
      return workstationId !== selectedScalesWorkstationId;
    }, true),
    mergeMap((message) => {
      const state = getState();
      const { weight, dims, requestId, workstationId } = message;
      if (workstationId !== selectedScalesWorkstationId) {
        return EMPTY;
      }
      const sellerWeightUnit = Global.selectSellerDefaultWeightUnit(state);
      const sellerDimsUnit = Global.selectSellerDefaultDimensionUnit(state);
      const convertedWeight = UnitConversionService.convertValue(weight, WeightUnit.Ounces, sellerWeightUnit);
      const convertedDims = {};
      if (dims) {
        convertedDims.length = UnitConversionService.convertValue(dims.length, DimensionUnit.Inches, sellerDimsUnit);
        convertedDims.width = UnitConversionService.convertValue(dims.width, DimensionUnit.Inches, sellerDimsUnit);
        convertedDims.height = UnitConversionService.convertValue(dims.height, DimensionUnit.Inches, sellerDimsUnit);
      }

      return of(Actions.readConvertedScaleResponse(convertedWeight, convertedDims, sellerWeightUnit, sellerDimsUnit, requestId));
    }),
  );
